import _setPrototypeOf from './setPrototypeOf.js';
import _isNativeReflectConstruct from './isNativeReflectConstruct.js';

function _construct(t, e, r) {
  if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments);
  var o = [null];
  o.push.apply(o, e);
  var p = new (t.bind.apply(t, o))();
  return r && _setPrototypeOf(p, r.prototype), p;
}

export { _construct as default };
